var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"750px"}},[(_vm.d_websiteUnitData)?_c('page-info-website-unit',{attrs:{"p_WebsiteUnitData":_vm.d_websiteUnitData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }